/* eslint-disable react/destructuring-assignment */
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import * as Yup from "yup";
// images

import { Col, Container, InputGroup, Row } from "react-bootstrap";
import menuBg from "../../assets/images/bg/menu/account.svg";
import email from "../../assets/images/icons/email2.svg";
import FooterBottom from "../../components/footerBottom";
import SubmitLoader from "../../components/SubmitLoader";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import { forgetPasswordAction } from "./actions";
import { regex } from "../../utils/regex";
import CustomButton from "../../components/Buttons/CustomButton";
import useReactRefresh from "../../hooks/useReactRefresh";

const validationSchema = Yup.object({
  email: Yup.string()
    .required("email can not be empty")
    .email("email must be a valid email address")
    .matches(regex.email, "email must be a valid email address"),
});
const cookie = new Cookies();

function ForgetPassword(props) {
  const [loader, setLoader] = useState(false);
  const initialState = {
    email: "",
  };
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const isSubmit = () => {
    setLoader(false);
  };

  const handleSubmit = (values, actions) => {
    setLoader(true);
    props.forgetPasswordAction(values, actions, props.history, null, isSubmit);
  };
  useEffect(() => {
    cookie.remove("forget_email");
    if (cookie.get("user_token")) {
      props.history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useReactRefresh();

  return (
    <>
      <Helmet>
        <title>Forgot Your Password - Clarity Cooperative</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header openMenu={handleOpenMenu} className="headerStyleWhite" logoWhite />
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <div className="loginscreen d-none">
        <Container className="py-3 py-sm-4 py-md-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={6}>
              <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ values, handleChange, handleBlur, touched, errors }) => {
                  return (
                    <Form className="loginForm">
                      <h1 className="text-white">Forgot Your Password?</h1>
                      <p className="text-white">
                        If you need help finding your password, don’t worry! It happens. Just fill out the form below and we’ll help.
                      </p>
                      <div className="accountCard">
                        <div className="my-2">
                          <InputGroup>
                            <Field
                              id="email"
                              name="email"
                              value={values.email}
                              className="form-control"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="E-mail*"
                              icons={email}
                              autoComplete="off"
                            />
                            <InputGroup.Text>
                              <i className="fa-regular fa-fw fa-envelope" />
                            </InputGroup.Text>
                          </InputGroup>
                          {touched.email && errors.email && <div className="errorMessage">{errors.email}</div>}
                        </div>
                      </div>

                      <div className="my-2" />
                      <div className="d-flex justify-content-between align-items-center">
                        <CustomButton variant="marketing" type="submit" disabled={props.meta.isLoading} gradient>
                          {loader ? (
                            <span className="d-inline-flex">
                              Sending... <SubmitLoader />
                            </span>
                          ) : (
                            <>Next</>
                          )}
                        </CustomButton>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
      <FooterBottom />
    </>
  );
}

const mapStateToProps = (state) => ({
  meta: state.meta,
});

export default connect(mapStateToProps, { forgetPasswordAction })(withRouter(ForgetPassword));
